<template lang="pug">
.form-item.msg-items
	.form-item__block(v-click-outside="close")
		.form-item__select.select( @click="toggleOpen")
			p.select__text( :class="value ? '' : 'select__text-placeholder'" :aria-placeholder="placeholder")
				| {{result}}

		SlideUpDown.select__slider(
			:duration="slideDuration"
			:active="isOpen"
		)
			.select__field.-no-padding-
				.select__item(
					v-for="(selectItem, idx) in selectData" :key="idx"
					@click="setOption(selectItem)",
				)
					p.select__text
						| {{selectItem.text}}

		Icon.form-item__icon(icon='arrow-down')

</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';

export default {
  directives: { clickOutside: vClickOutside.directive },
  components: { SlideUpDown },
  props: {
    value: {},
    selectData: {},
    placeholder: {}
  },
  data: () => ({
    isOpen: false,
    result: '',
    slideDuration: 200
  }),
  watch: {
    selectData() {
      const index = this.selectData.findIndex(item => item.text === this.value);
      this.result =
        index !== -1 ? this.selectData[index].text : 'Выберете поле';
    },
    value() {
      const index = this.selectData.findIndex(item => item.text === this.value);
      this.result =
        index !== -1 ? this.selectData[index].text : 'Выберете поле';
    }
  },
  mounted() {
    const index = this.selectData.findIndex(item => item.text === this.value);
    this.result = index !== -1 ? this.selectData[index].text : 'Выберете поле';
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    setOption(item) {
      this.close();
      this.result = item.text;
      this.$emit('params', {
        period: item.period,
        year: item.year
      });
    }
  }
};
</script>
